// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-select-style {
  padding: 0 10px;
}
.language-select-style .ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-radius: 15px;
}
.language-select-style .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background-color: white;
  color: #e8aa0d;
}
.ant-select-dropdown.drop {
  width: 140px !important;
}
.ant-select-dropdown.drop .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background-color: white;
  color: #e8aa0d;
}
.weather-component- .weather-list,
.weather-component-is-header .weather-list {
  width: 100%;
}
.weather-component- .weather-list .weather-info,
.weather-component-is-header .weather-list .weather-info {
  line-height: 20px;
  margin-right: 10px;
  margin-left: 15px;
}
.weather-component- .weather-list .weather-info > li:first-child,
.weather-component-is-header .weather-list .weather-info > li:first-child {
  color: rgba(0, 0, 0, 0.65);
}
.weather-component- .weather-list .weather-info > li:last-child,
.weather-component-is-header .weather-list .weather-info > li:last-child {
  margin-top: 5px;
}
.weather-component- .weather-list .weather-container,
.weather-component-is-header .weather-list .weather-container {
  display: -webkit-box;
  /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */
  display: -moz-box;
  /* Firefox 17- */
  display: -webkit-flex;
  /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */
  display: -moz-flex;
  /* Firefox 18+ */
  display: -ms-flexbox;
  /* IE 10 */
  display: flex;
  margin-bottom: 10px;
  padding-left: 10px;
}
.weather-component- > div:first-child {
  margin-top: 10px;
}
.weather-component- > div:first-child > span {
  color: #454545;
}
.weather-component- ul.weather-info {
  margin: 10px 10px 0px 10px;
}
.weather-component- ul.weather-info li:first-child {
  font-weight: bold;
  font-size: 12px;
  color: #454545;
}
.weather-component- ul.weather-info li:last-child {
  margin-top: 8px;
  font-weight: 400;
  font-size: 12px;
  color: #454545;
}
.weather-component-is-header {
  line-height: 15px;
}
.weather-component-is-header > div:first-child {
  align-items: center;
  margin-right: 10px;
}
.weather-component-is-header > div:first-child > span {
  color: #454545;
}
.weather-component-is-header:hover {
  background-color: transparent !important;
}
.weather-component-is-header ul.weather-info {
  margin: 0px 10px 0px 10px;
}
.weather-component-is-header ul.weather-info li:first-child {
  font-weight: bold;
  font-size: 12px;
  color: #454545;
}
.weather-component-is-header ul.weather-info li:last-child {
  margin-top: 8px;
  font-weight: 400;
  font-size: 12px;
  color: #454545;
}
`, "",{"version":3,"sources":["webpack://./src/components/index.less"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AAFA;EAGI,mBAAA;AAEJ;AALA;EAMI,uBAAA;EACA,cAAA;AAEJ;AAEA;EACE,uBAAA;AAAF;AADA;EAGI,uBAAA;EACA,cAAA;AACJ;AAEA;;EAGI,WAAA;AADJ;AAFA;;EAKM,iBAAA;EACA,kBAAA;EACA,iBAAA;AACN;AAAM;;EACE,0BAAA;AAGR;AADM;;EACE,eAAA;AAIR;AAhBA;;EAgBM,oBAAA;EAIJ,2CAA2C;EAHvC,iBAAA;EAKJ,gBAAgB;EAJZ,qBAAA;EAMJ,wDAAwD;EALpD,kBAAA;EAOJ,gBAAgB;EANZ,oBAAA;EAQJ,UAAU;EAPN,aAAA;EACA,mBAAA;EACA,kBAAA;AASN;AAJE;EACE,gBAAA;AAMJ;AALI;EACE,cAAA;AAON;AAXA;EAQI,0BAAA;AAMJ;AAdA;EAWM,iBAAA;EACA,eAAA;EACA,cAAA;AAMN;AAnBA;EAgBM,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAMN;AAFA;EAWE,iBAAA;AANF;AAJE;EACE,mBAAA;EACA,kBAAA;AAMJ;AALI;EACE,cAAA;AAON;AAJE;EACE,wCAAA;AAMJ;AAfA;EAaI,yBAAA;AAKJ;AAlBA;EAgBM,iBAAA;EACA,eAAA;EACA,cAAA;AAKN;AAvBA;EAqBM,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAKN","sourcesContent":[".language-select-style {\n  padding: 0 10px;\n  .ant-select:not(.ant-select-customize-input) .ant-select-selector {\n    border-radius: 15px; // 圆角\n  }\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background-color: white;\n    color: #e8aa0d;\n  }\n}\n\n.ant-select-dropdown.drop {\n  width: 140px !important;\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background-color: white;\n    color: #e8aa0d;\n  }\n}\n.weather-component-,\n.weather-component-is-header {\n  .weather-list {\n    width: 100%;\n    .weather-info {\n      line-height: 20px;\n      margin-right: 10px;\n      margin-left: 15px;\n      & > li:first-child {\n        color: rgba(0, 0, 0, 0.65);\n      }\n      & > li:last-child {\n        margin-top: 5px;\n      }\n    }\n    .weather-container {\n      display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */\n      display: -moz-box; /* Firefox 17- */\n      display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */\n      display: -moz-flex; /* Firefox 18+ */\n      display: -ms-flexbox; /* IE 10 */\n      display: flex;\n      margin-bottom: 10px;\n      padding-left: 10px;\n    }\n  }\n}\n.weather-component- {\n  & > div:first-child {\n    margin-top: 10px;\n    & > span {\n      color: #454545;\n    }\n  }\n  ul.weather-info {\n    margin: 10px 10px 0px 10px;\n\n    li:first-child {\n      font-weight: bold;\n      font-size: 12px;\n      color: #454545;\n    }\n    li:last-child {\n      margin-top: 8px;\n      font-weight: 400;\n      font-size: 12px;\n      color: #454545;\n    }\n  }\n}\n.weather-component-is-header {\n  & > div:first-child {\n    align-items: center;\n    margin-right: 10px;\n    & > span {\n      color: #454545;\n    }\n  }\n  &:hover {\n    background-color: transparent !important;\n  }\n  line-height: 15px;\n  ul.weather-info {\n    margin: 0px 10px 0px 10px;\n\n    li:first-child {\n      font-weight: bold;\n      font-size: 12px;\n      color: #454545;\n    }\n    li:last-child {\n      margin-top: 8px;\n      font-weight: 400;\n      font-size: 12px;\n      color: #454545;\n    }\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
